// In case you want to use a theme.

// import { css } from "styled-components";

const theme = {
    // flexCenter: css`
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    // `,
};

export default theme;